import React from 'react';



const Money = ({ value, precision = 2, prefix='$' }) => {
    let negativeSign = value < 0 ? "-" : "";
    let i = parseInt(value = Math.abs(Number(value) || 0).toFixed(precision)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;
    let val = prefix + negativeSign + (j ? i.substr(0, j) + ',' : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + ',') + (precision ? '.' + Math.abs(value - i).toFixed(precision).slice(2) : "");
    return <span>{val}</span>;
}

const Percentage = ({ value, multiplier = 100, precision = 2 }) => {
  // Ensure value is a number and finite to avoid NaN or Infinity
  const isValidNumber = !isNaN(value) && isFinite(value);
  const percentage = isValidNumber ? (value * multiplier).toFixed(precision) : 'N/A';
  return <span>{percentage}%</span>;
};

const LargeNumber = ({ value, precision = 2 }) => {
    let sign = value < 0 ? "-" : "";
    let char = '';
    let divisor = 1;

    try {
      let no = Math.abs(parseFloat(value.toString()));
      if (no < 1e6) {
          return Money({value: no, precision: precision, prefix: ''});
      }
      else if (no < 1e9) {
          char = 'M';
          divisor = 1e6;
      }
      else if (no < 1e12) {
          char = 'B';
          divisor = 1e9;
      }
      else if (no < 1e15) {
          char = 'T';
          divisor = 1e12;
      }
      return (
          <span>{sign + (no / divisor).toFixed(precision) + char}</span>
      )

    }
    catch(err) {}
    const isValidNumber = !isNaN(value) && isFinite(value);
    const formatted = isValidNumber ? value.toFixed(precision) : 'N/A';
    return <span>{formatted}</span>;
}


export { Money, Percentage, LargeNumber}
